import { Locales } from 'Core/constants/locale'

import { localeEn } from './locales/en'
import { localeEs } from './locales/es'
import { localeFr } from './locales/fr'

export const RESOURCES = {
	[Locales.en]: localeEn,
	[Locales.es]: localeEs,
	[Locales.fr]: localeFr
}

export const languageToTranslationOption = {
	English: 'en-US',
	Spanish: 'es-ES',
	French: 'fr-FR'
}

export const getTranslationOption = (languageCode: 'English' | 'Spanish' | 'French') => {
	return languageToTranslationOption[languageCode] || 'English' // Default to English if not found
}
